<template>
    <b-button v-if="$sessionsStorage.get('designation') == 'Admin' &&
        $sessionsStorage.get('nameUser') == 'Bhavneesh'" class="pull-right mb-1"
        :disabled="removeBtnName !== 'Remove Payment' && removeBtnName !== 'Remove Single Invoice'" @click="handleRemovePayment" size="sm" variant="warning"
        style="font-size: 0.675rem">
        {{ removeBtnName }}
        <b-spinner v-if="removeBtnName !== 'Remove Payment' && removeBtnName !== 'Remove Single Invoice'" small label="Small Spinner"></b-spinner>

    </b-button>
</template>

<script>
import CommonService from "../../services/CommonService.js";

export default {
    name: "RemoveSlineInvoiceButton",
    props: {
        BTNTitle: { type: String, required: true },
        Type: { type: String, required: true },
        SlineType: { type: String, required: true },
        TransportType: { type: String, required: true },
        SlinePayId: { type: String, required: true },
        SlineInvId: { type: String, required: true },
        allModuleId: { type: String, required: true }
    },
    data() {
        return {
            removeBtnName: this.BTNTitle?this.BTNTitle:"Remove Payment"
        };
    },
    methods: {
        async handleRemovePayment() {
            if (this.SlinePayId <= 0) {
                console.log("Please provide a valid SlinePayId");
                return;
            }

            this.removeBtnName = "Removing Please Wait .....";

            // Prepare payload
            const payload = {
                Type: this.Type,
                SlineType: this.SlineType,
                TransportType: this.TransportType,
                SlinePayId: this.SlinePayId,
                SlineInvId: this.SlineInvId,
                allModuleId: this.allModuleId,
                itemCode:'slineInvoiceRemove',
            };

            console.log('payload=>',payload);
            // return false;

            // Call the common function
            CommonService.removeSlineInvoice(payload)
                .then((response) => {
                    const { data, status, statusText } = response;
                    console.log("data PS=>", data.data);
                    this.removeBtnName = "Remove Payment";
                    if (status == 200 && data.FLAG==1) {
                        this.$emit("refresh-data");
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log("Catch on removePayment Error: ", error);
                });


            // Reset button name
            this.removeBtnName = "Remove Payment";
        }
    }
};
</script>


// WEBPACK FOOTER //
// RemoveSlineInvoiceButton.vue?31589912